import { Box, styled, Typography } from "@mui/material";

import { DefaultUrlWeb } from "config/Configuration";
import NumberFormats from "components/NumberFormats";

function WrapperValueBalance({ data }) {
  return (
    <BoxWrapper>
      <Box display="flex" marginBottom={2} alignItems="center">
        <img
          width={"25px"}
          height={"25px"}
          src={`${DefaultUrlWeb}${data?.imageUrl}`}
          alt={data?.name}
        />

        <Box display="flex" marginLeft={1}>
          <Typography variant="h5" marginLeft={0.5}>
            Balance:
          </Typography>
          <Typography
            variant="h6"
            color="text.main"
            fontWeight={600}
            marginLeft={0.5}
          >
            <NumberFormats value={data?.totalBalance} />
          </Typography>
          <Typography variant="subtitle1" marginLeft={0.5}>
            {data?.name}
          </Typography>
        </Box>
      </Box>

      <Box display="flex" alignItems="center" marginLeft={4.5}>
        <Typography variant="h5" marginLeft={0.5}>
          Value Blnc:
        </Typography>
        <Typography
          variant="h6"
          color="text.main"
          fontWeight={600}
          marginLeft={0.5}
        >
          <NumberFormats value={data?.costMarketUSDT} />
        </Typography>
        <Typography variant="subtitle1" marginLeft={0.5}>
          USDT
        </Typography>
      </Box>
    </BoxWrapper>
  );
}

const BoxWrapper = styled(Box)(() => ({
  cursor: "pointer",
}));
export default WrapperValueBalance;
